//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import AppMain from './components/AppMain'
import VeeValidate from 'vee-validate'
import ThemePicker from './components/RightLayer/ThemePicker/index'
Vue.use(Vant)
Vue.use(VeeValidate, {
  events: 'change|blur',
  fieldsBagName: 'fieldBags'
})
export default {
  name: 'mLayout',
  components: {
    AppMain,
    ThemePicker
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/mLayout.vue